import crudlModuleGenerator from '@/_CRUDL/modules/generator';

export default crudlModuleGenerator('banksWeb', {
  customKeys: {
    list: 'banks',
  },
  customEndpoints: {
    list: '/banks',
  },
});
